// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"src_views_Bridge_Jitsi_vue":"26f64cf3","src_views_Bridge_index_vue":"26305ad8","src_views_Layout_vue":"bd82c2ba"}[chunkId] + ".js";
};